import { getProjectsAffiliateLinks } from "../api";
import { affiliateLinkDetailsKeys } from "./keys";
import { useAffiliateLinkDetailQuery } from "./use-affiliate-link-detail-query";

export const useAffiliateLinkProjectsQuery = (id, enabled = true) =>
  useAffiliateLinkDetailQuery({
    queryKey: affiliateLinkDetailsKeys.projects(id),
    fetcher: getProjectsAffiliateLinks,
    id,
    dataKey: "affiliateLinksWithProjects",
    enabled,
  });
